// CRM 2.0 stage of a booking from the portal's own allotment row (M3-F2, M3.17, DC-113 / DC-146).
// Same rule as the backend's services/crm2/portalCard.js stageOf; used for the My Units filter and
// the "My Units" wording, which change only when the customer has a CRM 2.0 booking.
import { useEffect, useState } from "react";

export const STAGE_GROUPS = ["Shortlisted", "Application for Booking", "Allotment Letter", "Final Draft", "Registration", "Agreement Complete"];
export const OLD_GROUP = "Agreement (booked before CRM 2.0)";
export const UNIT_FILTER = ["All", ...STAGE_GROUPS, "Cancelled", OLD_GROUP];
const CANCELLED = ["Cancelled", "cancelled", "Refund Initiated", "Refund Processed", "Released", "Cancellation Done"];

export function stageGroup(ap) {
	if (!ap) return null;
	if (!ap.isCrm2) return OLD_GROUP;
	if (CANCELLED.includes(ap.status)) return "Cancelled";
	if (["Payment Pending", "Partial Payment Done"].includes(ap.status)) return "Shortlisted";
	if (ap.status === "Agreement Done") return "Agreement Complete";
	const crm = Array.isArray(ap.CRM) ? ap.CRM[0] : ap.CRM;
	if (crm?.finalDraftConfirmedAt) return "Registration";
	if (ap.allottedAt) return "Final Draft";
	if (crm?.finalReviewApprovedAt) return "Allotment Letter";
	return "Application for Booking";
}

// "the customer has a CRM 2.0 booking" — set by Home, read by the side menu (My Units wording)
const KEY = "crm2HasBooking";
const EVENT = "crm2:has-booking";
export function setHasCrm2Booking(has) {
	try {
		if (localStorage.getItem(KEY) === (has ? "1" : "0")) return;
		localStorage.setItem(KEY, has ? "1" : "0");
	} catch {
		/* storage blocked: wording falls back to today's */
	}
	window.dispatchEvent(new Event(EVENT));
}
export function useHasCrm2Booking() {
	const read = () => {
		try {
			return localStorage.getItem(KEY) === "1";
		} catch {
			return false;
		}
	};
	const [has, setHas] = useState(read);
	useEffect(() => {
		const on = () => setHas(read());
		window.addEventListener(EVENT, on);
		return () => window.removeEventListener(EVENT, on);
	}, []);
	return has;
}
